import Vue from 'vue';

const state = Vue.observable({
    systemCurrency: '',
    memberInfo: {},
    selectedWallet: localStorage.getItem('selectedWallet') || 'main',
    loggedIn: !!localStorage.getItem('gamingToken')
});

export function syncLoginState() {
    state.loggedIn = !!localStorage.getItem('gamingToken');
}

export default state;
